export default __webpack_public_path__ + "static/media/sword0.4cfb853c.svg";